import type { PostgrestError } from "../generated/models";

/**
 * A failed response from the generated client.
 *
 * Every non-2xx response narrows to this shape, whatever the operation.
 */
type FailedResponse = {
  status: number;
  data: PostgrestError;
};

/**
 * Builds an error describing a failed PostgREST response.
 *
 * PostgREST returns a message, and often a hint, explaining why a request was
 * rejected — a row-level security policy, a constraint violation, an expired
 * token. An empty body still parses to `{}`, so neither is guaranteed to be
 * present and the status code is the fallback.
 *
 * @param action what was being attempted, e.g. `"Fetch failed"`
 */
export function postgrestError(action: string, res: FailedResponse): Error {
  const detail = [res.data?.message, res.data?.hint].filter(Boolean).join(" — ");

  return new Error(
    detail
      ? `${action} with status code ${res.status}: ${detail}`
      : `${action} with status code ${res.status}`,
  );
}
